module.exports = __webpack_public_path__ + "img/logo-light.1cb2e32c.png";